
import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "../../assets/styles/BotaoWhatsApp.css";
import BotaoContato from "./BotaoContato";

export default function BotaoWhatsApp() {
  return (
    <BotaoContato className={"botao-whatsapp"} icon={<FaWhatsapp size={28} />} />
  );
}
